import TrackerDataTable from '@/applications/scrum/components/TrackerDataTable/TrackerDataTablePaginated'
import renderMixinMobile from '../ListCardMobileMixins/renderMixinMobile'
import { mapGetters } from 'vuex'
import SearchPaginatedMobileMixin from '@/agilis/mobile/ListCardMobileMixins/searchPaginatedMobileMixin'
import jsonLogic from '@/plugins/jsonLogic'
import Configuration from '@/agilis/util/Configuration'
import TitlePageMobile from '@/agilis/mobile/TitlePageMobile/TitlePageMobile.vue'
export default {
  name: 'TrackerDataTablePaginatedMobile',
  components: { TitlePageMobile },
  mixins: [TrackerDataTable, renderMixinMobile, SearchPaginatedMobileMixin],
  created () {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  mounted () {
    this.$store.commit('mobileDataTableStore/setAvailableViews', this.filtersInProfile.filter(f => f.route === this.filterRoute))
  },
  computed: {
    ...mapGetters({
      filtersInProfile: 'userDataStore/filters',
      searchTxtCommand: 'mobileDataTableStore/getSearchTxt',
      listViewsFilter: 'mobileDataTableStore/getAvaibleViews',
      viewSelected: 'mobileDataTableStore/getSavedSelectedView'
    })
  },
  methods: {
    renderColumn (colId, item) {
      if (colId) {
        const colConfig = this.dataTableConfiguration.columns[colId]
        return Configuration.datatable.renderColumn(colConfig, item)
      }
      return ''
    },
    searchDataText (newValue) {
      this.handleSearchTxtInput(newValue)
    },
    listTitle (itemLayout, item) {
      if (itemLayout.header?.jsonLogic) {
        return jsonLogic.apply(this.dataTableConfiguration.mobile.itemLayout.header.jsonLogic, item)
      }
      return this.renderColumn(this.headerMobile(this.dataTableConfiguration.mobile.itemLayout)?.value, item)
    },
    listSubTitle (itemLayout, item) {
      if (itemLayout.subHeader) {
        return this.renderColumn(this.subHeaderMobile(this.dataTableConfiguration.mobile.itemLayout)?.value, item) ?? ''
      }
      if (itemLayout.subHeader?.jsonLogic) {
        return jsonLogic.apply(this.dataTableConfiguration.mobile.itemLayout?.subHeader.jsonLogic, item)
      }
      return ''
    }
  },
  watch: {
    viewSelected (newValue) {
      this.applyFilter(newValue)
    },
    searchTxtCommand: 'searchDataText'
  }
}
